import script from "./SectionHeading.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionHeading.vue?vue&type=script&setup=true&lang=js"

import "./SectionHeading.vue?vue&type=style&index=0&id=bed2bb82&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bed2bb82"]])

export default __exports__